//api 接口处理
import request from "@/utils/request.js";
export default {
    //订单详情
    orderInfo (param) {
        return request.post("merchant/Customer.order/orderInfo", param, false, true);
    },
    //订单更新
    orderUpdate (param) {
        return request.post("merchant/Setting.label/labelIndex", param, false, true);
    },
    //订单列表
    orderList (param) {
        return request.post("merchant/Customer.order/orderRecord", param, false, true);
    },
    //订单删除
    orderDel (param) {
        return request.post("merchant/Customer.order/orderDel", param, false, true);
    },
    //员工列表
    staffLS (param) {
        return request.post("merchant/statistics/staffList", param, false, true);
    },
    //首页数据
    getIndexData (param) {
        return request.post("merchant/statistics/dataAnalysis", param, false, true);
    },

}